import { UserRoles } from '../api/tenant/models/UserDto'

interface UserRolePillProps {
    value?: UserRoles
    isProductAdmin?: boolean
}

const pillBaseStyle: React.CSSProperties = {
    color: 'white',
    padding: '3px 8px',
    borderRadius: '15px',
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'inline-block',
    fontSize: '12px',
}

function UserRolePill({
    value,
    isProductAdmin,
}: UserRolePillProps): React.JSX.Element | null {
    if (isProductAdmin) {
        return (
            <div
                style={{
                    ...pillBaseStyle,
                    backgroundColor: '#E74C3C',
                    whiteSpace: 'nowrap',
                }}
            >
                Product Admin
            </div>
        )
    }

    if (!value) {
        return null
    }

    const displayMap: Record<
        UserRoles,
        { text: string; style: React.CSSProperties }
    > = {
        [UserRoles.HM]: {
            text: 'Hiring Manager',
            style: {
                ...pillBaseStyle,
                backgroundColor: '#2ECC71',
            },
        },
        [UserRoles.TA]: {
            text: 'Talent Acquisition',
            style: {
                ...pillBaseStyle,
                backgroundColor: '#002d72',
            },
        },
        [UserRoles.JOB_SEEKER]: {
            text: 'Job Seeker',
            style: {
                ...pillBaseStyle,
                backgroundColor: '#6C63FF',
            },
        },
    }

    const pill = displayMap[value]
    if (!pill) {
        return null
    }

    return <div style={pill.style}>{pill.text}</div>
}

export default UserRolePill
